import { render, staticRenderFns } from "./TableFieldAdded.vue?vue&type=template&id=10c43a1a&scoped=true"
import script from "./TableFieldAdded.vue?vue&type=script&lang=js"
export * from "./TableFieldAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "10c43a1a",
  null
  
)

export default component.exports